import styled from 'styled-components';

export const FormHeaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.sizes.marginNormal}px;
`;
